<template>
  <div class="wrapper-partner">
    <div class="container text-center my-5 py-5">
      <h2>Ils nous font confiance</h2>
    </div>
    <div class="slider container">
      <div class="slide-track">
        <div class="slide">
          <img src="@/assets/partners/station-f.webp" alt="station-f Logo" />
        </div>
        <div class="slide">
          <img src="@/assets/partners/legallais.webp" alt="Legallais Logo" />
        </div>
        <div class="slide">
          <img src="@/assets/partners/sol-facade.webp" alt="sol façade Logo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarouselComponent",
};
</script>

<style scoped lang="scss">
.wrapper-partner {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/*@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-250px * 8));
  }
}*/

$animationSpeed: 40s; /* You can adjust this speed for faster or slower scrolling */

.slider {
  box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.125);
  height: 100px;
  margin: auto;
  /*overflow: hidden;
  position: relative;

  /*&::before,
  &::after {
    content: "";
    height: 100px;
    position: absolute;
    width: 200px;
    z-index: 2;
  }

  &::before {
    left: 0;
    top: 0;
  }

  &::after {
    right: 0;
    top: 0;
    transform: rotateZ(180deg);
  }*/

  .slide-track {
    animation: scroll $animationSpeed linear infinite;
    display: flex;
    justify-content: flex-start;
    gap: 30px;
    overflow-x: auto;
    padding-left: 22vw;
    @media screen and (min-width: 768px) {
      justify-content: center;
      padding-left: 0vw;
    }
    /*width: calc(
      250px * 16
    );*/ /* Adjust based on number of slides for smooth looping */
  }

  /*.slide {
    height: 100px;
    width: 250px;
  }*/

  .slide img {
    height: 100px;
    margin: 0px 10px;
    @media screen and (min-width: 768px) {
      justify-content: center;
      padding-left: 0vw;
    }
  }
}
</style>
